export const DEFAULT_COUNTRY_CODE = 'US'
